
import axios from 'axios';
import React, { useState, useEffect,useRef, useMemo} from 'react';
import {getCookie,getCsrfToken} from './get_csrfToken'

const custom_api_func2 = axios.create({
    baseURL: 'https://api.successguardian.in/',
    withCredentials: true
});

custom_api_func2.interceptors.request.use(config => {
    const dsrtokenid = localStorage.getItem('dsrtokenid');  // Or get from context
    if (dsrtokenid) {
        config.headers['X-token-Id'] = dsrtokenid;
    }
    return config;
});

function logout() {
    custom_api_func2.get('api/logout/');
    localStorage.clear()
    window.location.href = '/';
}

export default custom_api_func2;